import './index.css'

const NotFound = () => {}

export default NotFound